import { ReactNode, useState } from 'react';
import { LuEye, LuEyeOff } from 'react-icons/lu';

const fixedInputClass =
  'rounded-md appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-purple-500 focus:border-purple-500 focus:z-5 sm:text-sm';

interface InputProps {
  handleChange: React.ChangeEventHandler<HTMLInputElement>;
  value: string;
  labelText?: string;
  labelFor: string;
  id: string;
  name: string;
  type: string;
  isRequired: boolean;
  placeholder: string;
  customClass?: string;
  extra?: ReactNode;
  note?: string;
  tabIndex?: number;
  extraInline?: boolean;
}

export default function Input(props: InputProps) {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = props.type === 'password';

  return (
    <div
      className={`py-2 flex flex-col gap-2 ${
        props.type === 'hidden' ? 'hidden' : 'flex'
      }`}
    >
      {props.labelText && props.labelFor && (
        <div className="flex flex-row gap-2">
          <label htmlFor={props.labelFor} className="text-sm font-medium grow">
            {props.labelText}
          </label>

          {props.extra && !props.extraInline && props.extra}
        </div>
      )}
      <div
        className={`grid ${
          props.extraInline ? 'grid-cols-6 gap-2' : 'grid-cols-1'
        }`}
      >
        <div className="col-span-4 relative">
          <input
            onChange={props.handleChange}
            value={props.value}
            id={props.id}
            name={props.name}
            type={showPassword ? 'text' : props.type}
            required={props.isRequired}
            className={`${fixedInputClass} ${props.customClass ?? ''} ${
              isPassword ? 'pr-8' : ''
            }`}
            placeholder={props.placeholder}
            tabIndex={props.tabIndex ?? undefined}
          />

          {isPassword && (
            <button
              type="button"
              className="absolute right-2 top-1/2 -translate-y-1/2 z-10"
              aria-label={showPassword ? 'Hide password' : 'Show password'}
              onClick={() => setShowPassword((prev) => !prev)}
            >
              {showPassword ? <LuEye /> : <LuEyeOff />}
            </button>
          )}
        </div>

        {props.extra && props.extraInline && (
          <div className="col-span-2">{props.extra}</div>
        )}
      </div>

      {props.note && <p className="text-sm text-gray-500 mb-2">{props.note}</p>}
    </div>
  );
}
